"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_1 = require("./styled");
const InterceptFetch_1 = __importDefault(require("./InterceptFetch"));
const TopProgressBar = () => {
    const [completed, setCompleted] = (0, react_1.useState)(0);
    const [isShown, setIsShown] = (0, react_1.useState)(false);
    const enableProgressBar = () => {
        setIsShown(true);
        setCompleted(10);
    };
    const disableProgressBar = () => {
        setCompleted(100);
    };
    (0, react_1.useEffect)(() => {
        if (isShown) {
            const interval = setInterval(() => {
                setCompleted(prev => (prev < 90 ? prev + 10 : prev));
            }, 500);
            return () => {
                clearInterval(interval);
            };
        }
    }, [isShown]);
    (0, react_1.useEffect)(() => {
        if (completed === 100) {
            const timeout = setTimeout(() => {
                setCompleted(0);
                setIsShown(false);
            }, 500);
            return () => clearTimeout(timeout);
        }
    }, [completed]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(InterceptFetch_1.default, { disableProgressBar: disableProgressBar, enableProgressBar: enableProgressBar }),
        react_1.default.createElement(styled_1.Container, null,
            react_1.default.createElement(styled_1.Filler, { width: completed, isShown: isShown }))));
};
exports.default = TopProgressBar;
